import React, { ReactElement } from 'react';
import { Form, Input } from 'antd';
import { regExp } from 'utilities/regExp/regExp';
import { Rule } from 'antd/lib/form';

interface Props {
  name: string;
  label: string;
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
  rules?: Rule[];
}

export default function FieldPhone(props: Props): ReactElement {
  const {
    name,
    label,
    placeholder,
    required = false,
    disabled = false,
    rules = disabled
      ? []
      : [
          {
            pattern: regExp.phoneFormat,
            message: 'Please format phone number as XXX-XXX-XXXX',
            required,
          },
        ],
  } = props;
  return (
    <Form.Item name={name} label={label} rules={rules}>
      <Input
        placeholder={placeholder ?? 'i.e 711-852-8162'}
        style={{ width: '100%' }}
        disabled={disabled}
      />
    </Form.Item>
  );
}
